import Vue from 'vue'
import Vuex from 'vuex'
import VisaTypeList from './modules/visaTypeList'
import AuthUser from '../store/modules/auth-user'
import PermissionList from './modules/permission'
import RoleList from './modules/role'
/**/
import UserList from './modules/user'
import CountryList from './modules/country'
import OfficeList from './modules/office'
import VisaTypeCondition from './modules/visaTypeCondition';
import VisaTypeConditionList from './modules/VisaTypeConditionList';
import TrekkingAgencyList from './modules/TrekkingAgencyList'
import DocumentType from './modules/documentType'
import CommonList from './modules/common'
import Notification from './modules/notification'
import TrekkingSingle from './modules/trekking'
import VisaRequestSingle from './modules/visaRequest'
import TravellerSingle from './modules/traveller'
import Tippani from '../store/modules/tippani'
import Transfer from "../store/modules/visa-request/transfer";
import Certification from '../store/modules/ceritification';
import TerminalGroup from '../store/modules/terminal_group';
import TerminalDesk from "../store/modules/terminal_desk";
import IssuedVisaReport from '../store/modules/reports/issue_visa_report';
import ValidIssuedVisaReport from "../store/modules/reports/valid_issue_visa_report";
import ValidConvertedVisaReport from "../store/modules/reports/valid_converted_visa_report";
import SectionWiseIssuedVisaReport from '../store/modules/reports/section-wise-issue_visa_report';
import OverStayProcessedVisaReport from '../store/modules/reports/overstay_processed_visa_report';
import EntryVisaReport from '../store/modules/reports/entry-visa-report';
import MissionIssuedVisaReport from '../store/modules/reports/mission_issue_visa_report';
import RejectedVisaReport from '../store/modules/reports/rejected_visa_report';
import CancelledVisaReport from '../store/modules/reports/cancelled_visa_report';
import VerifiedVisaReport from '../store/modules/reports/verified_visa_report';
import PaidVisaReport from '../store/modules/reports/paid_visa_report';
import RevenueReport from '../store/modules/reports/revenue_report';
import OverAllReport from '../store/modules/reports/over_all_reveue_report';
import OfficerRevenueReport from '../store/modules/reports/revenue_report_officer';
import LateStayReport from '../store/modules/reports/late_stay_report';
import OverstayReport from "../store/modules/reports/overstay_report";
import PreviousStayReport from "../store/modules/reports/previous_stay_report";
import UpdatedPreviousStayReport from "../store/modules/reports/updated_previous_stay_report";
import ArrivalDepartureReport from '../store/modules/reports/arrival_departure_report';
import DeportedReport from '../store/modules/deported/deported';
import OldArrivalDepartureReport from '../store/modules/reports/old_arrival_departure_report';
import EntryRefuseReport from '../store/modules/reports/entry_refuse_report';
import NepaleseEntryRefuseReport from '../store/modules/reports/nepalese_entry_refuse_report';
import OffloadReport from '../store/modules/reports/offload_report';
import TravellerHistoryReport from '../store/modules/reports/traveller_history_report';
import TravellerHistoryStayingInNepalReport from '../store/modules/reports/traveller_staying_in_nepal_history_report';
import TrekkerReport from '../store/modules/reports/trekker_report';
import BlackDelistReport from '../store/modules/reports/black_list_delist';
import TrekkingRevenueReport from '../store/modules/reports/trekking_revenue_report';
import MuddhaEntryReport from '../store/modules/reports/muddha_report';
import VisaRequestList from '../store/modules/visa-request/visa_request';
import NonVisaCertification from '../store/modules/non_visa_certification';
import SettingReport from '../store/modules/setting';
import NewVisaEntry from '../store/modules/visa-request/new_visa_entry';
import PlanUpgrade from '../store/modules/visa-request/plan_update'
import Print from '../store/modules/print'
import Appointment from '../store/modules/appointment'
import AppointmentReport from '../store/modules/reports/appointment_report';

import DocumentRecord from '../store/modules/reports/document_record';
import ManualEntryReport from '../store/modules/reports/manual_entry_report';
import SCPReport from '../store/modules/reports/special_case_payment_report';
import ReloadReport from "../store/modules/reports/reload_report";
import ServiceProvider from "../store/modules/service_provider";
import TravellersScanReport from "../store/modules/reports/traveller_scan_report";
import MultipleArrivalDepartureReport from "../store/modules/multiple_arrival_departure_report";
import WorkingVisaReport from "../store/modules/reports/working_visa_report";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        VisaTypeList,
        PermissionList,
        RoleList,
        UserList,
        CommonList,
        AuthUser,
        Notification,
        TrekkingSingle,
        VisaRequestSingle,
        CountryList,
        OfficeList,
        TrekkingAgencyList,
        TravellerSingle,
        VisaTypeCondition,
        VisaTypeConditionList,
        DocumentType,
        Tippani,
        Transfer,
        Certification,
        TerminalGroup,
        TerminalDesk,
        IssuedVisaReport,
        ValidIssuedVisaReport,
        SectionWiseIssuedVisaReport,
        OverStayProcessedVisaReport,
        EntryVisaReport,
        MissionIssuedVisaReport,
        RejectedVisaReport,
        CancelledVisaReport,
        VerifiedVisaReport,
        PaidVisaReport,
        RevenueReport,
        OverAllReport,
        MultipleArrivalDepartureReport,
        OfficerRevenueReport,
        LateStayReport,
        OverstayReport,
        PreviousStayReport,
        ArrivalDepartureReport,
        DeportedReport,
        OldArrivalDepartureReport,
        EntryRefuseReport,
        NepaleseEntryRefuseReport,
        OffloadReport,
        TravellerHistoryReport,
        TravellerHistoryStayingInNepalReport,
        TrekkerReport,
        BlackDelistReport,
        TrekkingRevenueReport,
        VisaRequestList,
        NonVisaCertification,
        SettingReport,
        NewVisaEntry,
        PlanUpgrade,
        Print,
        DocumentRecord,
        UpdatedPreviousStayReport,
        MuddhaEntryReport,
        Appointment,
        AppointmentReport,
        ManualEntryReport,
        SCPReport,
        ValidConvertedVisaReport,
        ReloadReport,
        ServiceProvider,
        TravellersScanReport,
        WorkingVisaReport
    }
});

export default store
